module.exports = __webpack_public_path__ + "img/logoBewell.2a0a334d.svg";